// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { fetchAllAccounts, updateAccountNotes } from '../../actions/accountActions';

import Table from '../Table.jsx';

type Props = {
  allAccounts: Object[],
  activeAccount: Object,
  fetchAllAccounts: Function,
  updateAccountNotes: Function,
}

class AllAccountsTableComponent extends Component<Props> {
  componentDidMount() {
    this.props.fetchAllAccounts();
  }

  handleSaveRow = (id: string, formData: Object) => {
    const { activeAccount } = this.props;
    this.props.updateAccountNotes(id, {
      ...formData.values,
      editor: `${activeAccount.name}, ${activeAccount.credential}`,
      editDate: moment().toISOString(),
    });
  }

  render() {
    const columns = [
      {
        Header: 'Username',
        id: 'username',
      },
      {
        Header: 'Name',
        id: 'name',
      },
      {
        Header: 'Credential',
        id: 'credential',
      },
      {
        Header: 'Instutition',
        id: 'institution',
      },
      {
        Header: 'Last Login',
        id: 'lastLogin',
        cell: ({ lastLogin }) => moment(lastLogin).format('DD-MM-YY, HH:mm:ss'),
      },
      {
        Header: 'Account Creation',
        id: 'creation',
        cell: ({ creation }) => moment(creation).format('DD-MM-YY, HH:mm:ss'),
      },
    ];

    return <Table
      data={this.props.allAccounts || []}
      columns={columns}
      style={{}}
      handleSaveRow={this.handleSaveRow}
    />;
  }
}

const mapStateToProps = state => ({
  allAccounts: state.account.allAccounts,
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  fetchAllAccounts: () => dispatch(fetchAllAccounts()),
  updateAccountNotes: (accountId, data) => dispatch(updateAccountNotes(accountId, data)),
});

const AllAccountsTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AllAccountsTableComponent);

export default AllAccountsTable;



// WEBPACK FOOTER //
// ./client/src/components/accountPages/AllAccountsTable.jsx